import Box from "ds/components/Box";
import Tab from "ds/components/Tab";
import useTypedContext from "hooks/useTypedContext";

import { FiltersContext } from "..";
import { FilterMode } from "../types";
import styles from "./styles.module.css";

type SidebarHeadingContentProps = {
  setMode: (mode: FilterMode) => void;
  mode: FilterMode;
};

const SidebarHeadingContent = ({ setMode, mode }: SidebarHeadingContentProps) => {
  const { enableViews } = useTypedContext(FiltersContext);

  return (
    <Box
      direction="row"
      gap="medium"
      align="center"
      className={styles.tabs}
      role="tablist"
      aria-label="Filter sidebar"
    >
      <Tab
        onClick={setMode}
        isActive={mode === FilterMode.Filters}
        id={FilterMode.Filters}
        label="Filters"
        disabled={!enableViews}
        aria-disabled={!enableViews ? "true" : undefined}
      />
      {enableViews && (
        <Tab
          onClick={setMode}
          isActive={mode === FilterMode.Views}
          id={FilterMode.Views}
          label="Views"
        />
      )}
    </Box>
  );
};

export default SidebarHeadingContent;
